import React from 'react'
import PropTypes from 'prop-types'
import Dialog from 'components/dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogActions from '@material-ui/core/DialogActions'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import FileDownloadOutlinedIcon from 'components/material-symbol/icons/FileDownload'
import { useDialogTitleStyles } from 'components/dialog/use-dialog-title-styles'

const DownloadReportDialog = ({
  open,
  onClose,
  onDownload,
  isDownloading,
  periodLabel,
}) => {
  const classes = useDialogTitleStyles()

  return (
    <Dialog
      isOpen={open}
      onClose={onClose}
      disableClose={isDownloading}
      maxWidth="xs"
      fullWidth
      showCloseButton
      classes={{ paper: classes.dialogPaper }}
    >
      {({ closeDialog }) => (
        <>
          <DialogTitle disableTypography classes={{ root: classes.titleRoot }}>
            <Typography component="h2" className={classes.title}>
              Download report
            </Typography>
            <Typography className={classes.bodyText}>
              Download a PDF of your analytics for {periodLabel}. It includes
              everything on this page and will save to your device
              automatically.
            </Typography>
          </DialogTitle>
          <DialogActions className={classes.actions}>
            <Button
              onClick={closeDialog}
              color="primary"
              disabled={isDownloading}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              startIcon={<FileDownloadOutlinedIcon />}
              onClick={onDownload}
              disabled={isDownloading}
            >
              {isDownloading ? 'Generating...' : 'Download PDF'}
            </Button>
          </DialogActions>
        </>
      )}
    </Dialog>
  )
}

DownloadReportDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onDownload: PropTypes.func.isRequired,
  isDownloading: PropTypes.bool.isRequired,
  periodLabel: PropTypes.string.isRequired,
}

export default DownloadReportDialog
